import { javascript } from "@codemirror/lang-javascript";
import { markdown, markdownLanguage } from "@codemirror/lang-markdown";
import { languages } from "@codemirror/language-data";
import { EditorState } from "@codemirror/state";
import { githubDark, githubLight } from "@uiw/codemirror-theme-github";
import { basicSetup } from "codemirror";

export const extensions = (theme?: "light" | "dark") => [
	basicSetup,
	markdown({
		codeLanguages: languages,
		base: markdownLanguage,
		defaultCodeLanguage: javascript({
			// Code cells support JSX
			jsx: true,
			// Code cells do not support TypeScript
			typescript: false,
		}),
	}),
	...(theme ? [theme === "light" ? githubLight : githubDark] : [githubLight, githubDark]),
];

export function createMarkdownEditorState(
	doc: string,
	{ theme = "light" }: { theme: "light" | "dark" }
) {
	return EditorState.create({ doc, extensions: extensions(theme) });
}
